<template>
<div class="train">
  <div class="container">
    <div class="jiaoliu">
      <ul>
        <li class="" style="    background-image: url(/static/img/icn_jiaoliubg.png); font-size: 18px;font-family: PingFang SC;font-weight: bold;color: #FFFFFF;width:124px">
          <img class="adv" src="/static/img/icon_weixin.png" /> 交流
        </li>
        <li class="">
          <router-link to="/ApplySociety?type=tsjy">投诉建议</router-link>
        </li>
        <div class="sline"></div>
        <li class="">
          <router-link to="/ApplySociety?type=zxly">在线留言</router-link>
        </li>
        <div class="sline"></div>
        <li class="">
          <router-link to="/ApplySociety?type=xfqd">信访渠道</router-link>
        </li>
      </ul>
    </div>
    <div class="title-box clearfix">
        <div class="list">
            <ul class="clearfix">
                <li class="active">友情链接</li>
            </ul>
        </div>
    </div>
    <div class="imgList" >
        <ul class="clearfix">
            <li v-for="(link , index) in  yq_links" :key="index">
                <a :href="link.url">
                    <img :src="`${global.remoteIp}/uploads/${link.picsrc}`">
                </a>
            </li>
        </ul>
    </div>
  </div>
</div>
</template>

<script>
import global from "@/components/PublicComs/Common.vue";
export default {
  props: {},
  components: {},
  data() {
    return {
      hz_links: [],
      fz_links: [],
      yq_links: [],
      global,
      selink1:"--合作单位--",
      selink2:"--行业分站--",
      selink3:"--友情链接--"
    };
  },

  mounted() {
    this.$axios
      .get("/api/links?sort=-createdAt&limit=100")
      .then((res) => {
        if (res.data) {
          for (var i = 0; i < res.data.data.length; i++) {
            if(res.data.data[i].type == "合作平台")
            {
              this.hz_links.push(res.data.data[i]);
            }else if(res.data.data[i].type == "行业分站")
            {
              this.fz_links.push(res.data.data[i]);
            }else if(res.data.data[i].type == "友情链接")
            {
              this.yq_links.push(res.data.data[i]);
            }
          }
        }
      })
      .catch((err) => {
        this.web_links = [
          {
            url: "http://www.mohurd.gov.cn/",
            name: "中华人民共和国住房和",
          },
          {
            url: "http://www.chinacoal.gov.cn/templet/3/",
            name: "中国煤炭工业网",
          },
          {
            url: "http://www.cweun.org/",
            name: "中国水利工程协会",
          },
          {
            url: "http://www.coalchina.org.cn/",
            name: "中国煤炭工业协会",
          },
          {
            url: "http://www.ciesc.cn/",
            name: "中国化工学会",
          },
          {
            url: "http://www.chinasafety.ac.cn/",
            name: "中国安全生产科学研究",
          },
        ];
      });
  },

  methods: {
    openLink(url){
      window.open(url)
    }
  },
  watch: {
    selink1(newVal){
      window.open(newVal)
    },
    selink2(newVal){
      window.open(newVal)
    },
    selink3(newVal){
      window.open(newVal)
    }
  }
};
</script>

<style scoped>
.train{
  margin-bottom: 28px;
}
.jiaoliu ul li{
  display: inline-block;
    height: 77px;
    width: 151px;
    line-height: 77px;
    /* margin: auto; */
    text-align: center;
font-size: 16px;
font-family: PingFang SC;
font-weight: 500;
color: #333333;
}
.jiaoliu ul .sline{
  width: 1px;
  height: 16px;
  background: #DCDCDC;
  display: inline-block;
}
.adv{
  vertical-align: middle;
}
.jiaoliu{
  margin-bottom: 75px;
  border: 1px solid #F1F3F9;
}
.train .imgList li{
  width: 25%;
    height: 51px;
    margin-left:10px;
}
</style>